export const defaultGroupInput = {
  enableDiscount: false,
  isBudgetShared: false,
  isLinkEnabled: false,
  name: "",
  seasonEndAt: "",
  seasonName: "",
  seasonStartAt: "",
  shareAccount: false,
};

export type GroupPage =
  | "banking"
  | "invoicing"
  | "rosters"
  | "cards"
  | "budget"
  | "staff"
  | "settings"
  | "active";

export type GroupPageData = {
  participantId?: string;
  isSingular?: boolean;
};
